"use client"

export type FilterTriggerLabelProps = {
  prefix: string
  value: string
}

export function FilterTriggerLabel({ prefix, value }: FilterTriggerLabelProps) {
  return (
    <div className="flex min-w-0 flex-1 items-center gap-1 overflow-hidden">
      <span className="shrink-0 text-white/50">{prefix}: </span>
      <span className="min-w-0 truncate text-white">{value}</span>
    </div>
  )
}
